export default __webpack_public_path__ + "static/media/content_copy.e379c1a5.svg";